import { NgFor, NgIf, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    InjectionToken,
    Input,
    OnInit,
    Optional,
    PLATFORM_ID,
    ViewChild,
    computed,
    inject,
    signal,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SearchResultHotelsCard } from '@core/models/DTOs/hotel.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { SearchResultUiService } from '../../services/search-result-ui.service';
import { PlpCardsSkeletonComponent } from '../plp-cards-skeleton/plp-cards-skeleton.component';
import { cdnUrl, WINDOW } from 'apps/ihowebsite/src/app/app.module';
import { DatepickerService } from '@shared/services/datepicker.service';

@Component({
    selector: 'iho-plp-card',
    templateUrl: './plp-cards.component.html',
    styleUrls: ['./plp-cards.component.scss'],
    standalone: true,
    providers: [
        //   {
        //    provide: WINDOW,
        //    useFactory: (platformId: Object) => {
        //     return isPlatformBrowser(platformId) ? window : {};
        //    },
        //    deps: [PLATFORM_ID],
        //   },
    ],
    imports: [NgIf, NgFor, SharedModule, RouterLink, RialToTomanPipe, PlpCardsSkeletonComponent],
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlpCardsComponent implements OnInit {
    route = inject(ActivatedRoute);
    swiperService = inject(SwiperService);
    searchBoxService = inject(SearchBoxService);
    plpUiService = inject(SearchResultUiService);
    datepickerService = inject(DatepickerService);
    @Input() type: 'hotel' | 'ecolodge' = 'hotel';
    @Input() id = 0;
    @Input() dataSource!: SearchResultHotelsCard;
    @Input() urlSearch!: any;
    @Input() lazyLoad!: boolean;
    @ViewChild('likeBtn') likeBtn!: ElementRef;
    @ViewChild('commentAccordion') accordion!: ElementRef;
    @ViewChild('accordionBody') accordionBody!: ElementRef;
    @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
    accommodation = this.route.snapshot.data['accommodation'] || 'hotel';
    csrStatus = signal(false);
    cdnUrl = cdnUrl;
    isServer: boolean;
    constructor(
        @Optional() @Inject(WINDOW) private window: Window,
        @Inject(PLATFORM_ID) private platformId: Object,
        private cdr: ChangeDetectorRef
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.navigatorVal = /Android|iPhone/.test(this.window.navigator.userAgent);
        }
        this.isServer = isPlatformServer(this.platformId);
    }
  

    authService = inject(AuthService);
    router = inject(Router);
    navigatorVal = true;
    pdpUrl = '';
    commentIsLongEnough = false;
    isBrowser = false;
    swiperConfig!: SwiperOptions;
    showArrowPrev = false;
    showArrowNext = true;
    loadingFavorite = false;

    ngOnInit(): void {
      
        const config = {
            slide: 1,
            pagination: true,
        };

        this.swiperConfig = this.swiperService.SwiperConfig(config);

        if (isPlatformBrowser(this.platformId)) {
            this.csrStatus.set(true);
            if (
                this.dataSource?.LastVote?.Description &&
                this.dataSource?.LastVote.Description.split(' ').length > 20
            ) {
                this.commentIsLongEnough = true;
            }
        }
        this.filteredPictures();
    }
    filteredPictures() {
        return this.accommodation == 'ecolodge' ? this.dataSource.CardData.Pictures.slice(0, 3) : this.dataSource.CardData.Pictures;
    }

    navigateToPDP(url: string, event: any = {}) {
        event.preventDefault();
        let params = new HttpParams();
        let getParams = this.route.snapshot.queryParams;

        this.plpUiService.resetPlpResults();

        if (url.includes('?')) {
            let prefixUrl = url.split('?')[0];
            let UrlParams = url.split('?')[1].split('&');
            UrlParams.forEach((pair) => {
                const [key, value] = pair.split('=');
                params = params.append(key, value);
            });

            let startDate = params.get('date');
            let endDate = params.get('endDate');

            if (startDate && endDate) {
                this.searchBoxService.dateRange = [startDate, endDate];
            }

            this.router.navigate([prefixUrl], {
                queryParams: {
                    date: startDate,
                    endDate: endDate,
                    refer: params.get('refer') || null,
                    city: getParams['city'] || null,
                },
            });
        } else {
            this.router.navigate([url], {
                queryParams: {
                    date: this.datepickerService._startDate(),
                    endDate: this.datepickerService._endDate(),
                    refer: 'searchresult',
                    //  city: getParams['city'] || null,
                },
            });
        }
    }

 onSlideChange(ev: any) {
  if (!this.navigatorVal) {
   if (ev[0].activeIndex === 0) this.showArrowPrev = false;
   else {
    this.showArrowPrev = true;
    this.showArrowNext = true;
   }
   if (ev[0].activeIndex === 3) this.showArrowNext = false;
  } else {
   if (ev[0].activeIndex === 0) this.showArrowPrev = false;
   else {
    this.showArrowPrev = true;
    this.showArrowNext = true;
   }
  }
 }

    addToFavorite() {
        // if ( this.authService.getUserData()() ) {
        //   if (!this.loadingFavorite) {
        //     this.loadingFavorite = true
        //     // this.isFavorite = !this.isFavorite
        //     this.hotelUiService.addToFavorite().subscribe(
        //       response => {
        //         this.loadingFavorite = false
        //         this.isFavorite = response.data.isFavorite
        //         if (this.isFavorite) {
        //           this.notificationService.success('به لیست علاقه‌مندی های من اضافه شد')
        //         } else {
        //           this.notificationService.success('از لیست علاقه‌مندی ها حذف گردید')
        //         }
        //         this.cdref.detectChanges()
        //       }
        //     )
        //   }
        // } else {
        //   this.loginRegisterUiService.showMyModal();
        // }

        this.likeBtn.nativeElement.classList.toggle('is-active');
    }

    toggleCommentAccordion() {
        if (this.accordion) this.accordion.nativeElement.classList.toggle('is-open');
    }

    nextSlide(event: any) {
        event.stopPropagation();
        this.swiper?.swiperRef.slideNext(100);
    }

    previousSlide(event: any) {
        event.stopPropagation();
        this.swiper?.swiperRef.slidePrev(100);
    }
    onImageError(event: any) {
      //  if (this.isServer) return; // تو SSR اجرا نکن
        const target = event.target as HTMLImageElement;
        target.src = 'assets/images/no-image.jpg';
    }
}
